import type { IxcMutualfundsV1VenueOrderKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../util/routing/entity-paths';

export const MUTUAL_FUNDS_VENUE_ORDER_BASE_PATH = getResolvedPath('/clearing/operations/mutualfunds/venue-order');

export const getMutualFundsVenueOrderPath: EntityPathBuilder<IxcMutualfundsV1VenueOrderKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return MUTUAL_FUNDS_VENUE_ORDER_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.venueOrderId) {
        return undefined;
      }

      return getResolvedPath(`${MUTUAL_FUNDS_VENUE_ORDER_BASE_PATH}/$venueOrderId`, context.keys);
    }
  }
};

export function getMutualFundsVenueOrderDetailPath(venueOrderId: string | undefined) {
  if (!venueOrderId) {
    return undefined;
  }

  return getMutualFundsVenueOrderPath({ kind: 'detail', keys: { venueOrderId } });
}
